import React, { useEffect, useState } from 'react';
import classes from "./MyMatches.module.css";
import Layout from '../component/Layout';
import SubLayout from '../component/SubLayout';
import { useNavigate } from 'react-router-dom';
import BottomNavbar from '../component/BottomNavbar';
import Container from '../component/Container';
import { userMatchesApi } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
import MatchLayout2 from '../component/MatchLayouts/MatchLayout2';
import MatchLayoutForPrediction from '../component/MatchLayouts/MatchLayoutForPrediction';
import SmallLoader from '../component/SmallLoader';
import { removeUserDetails } from '../store/slices/userSlice';
import { toast } from 'react-toastify';
import Header from '../component/Header';
import { useTranslation } from 'react-i18next';

const MyMatches = () => {
    const navigate = useNavigate();
    const [type, setType] = useState("fantasy");
    const [userMatches, setUserMatches] = useState(null);
    const { userDetails } = useSelector(state => state.persisted?.userSlice);

    const [loader, setLoader] = useState(true);
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const fetchUserMatches = async (load) => {
        try {
            if (load) {
                setLoading(true);
            }
            setLoader(true);
            const response = await userMatchesApi(userDetails?.token);
            console.log(response, 'response...');
            setUserMatches({
                fantasy: response?.data?.fantasy,
                prediction: response?.data?.prediction
            });

            setLoading(false);
            setLoader(false);
        } catch (error) {
            if (error?.response?.status == 403) {
                dispatch(removeUserDetails());
                toast.error("Login Again!");
                navigate('/');
            }
            else {
                setLoader(false);
                setLoading(false);
                toast.error(error?.response?.data?.message || error?.response?.message || error?.data?.message || "Something Went Wrong!");
                console.log(error, 'error---');
            }
        }
    }

    useEffect(() => {
        fetchUserMatches(true);
    }, []);

    useEffect(() => {
        if (!loader) {
            const intervalId = setInterval(() => {
                if (!document.hidden) {
                    fetchUserMatches(false);
                }
            }, 10000);
            return () => clearInterval(intervalId);
        }

    }, [loader]);

    return (
        <Layout>
            <SubLayout>

                <Header active={1} />
                <div className={classes.tabs_container}>
                    <button type='button' className={`${classes.tab_option} ${type === "fantasy" && classes.active}`}
                        onClick={() => setType("fantasy")}
                    >
                        {t("87")}
                    </button>
                    {/* <button type='button' className={`${classes.tab_option} ${type === "predict" && classes.active}`}
                            onClick={() => setType("predict")}
                        >
                            {t("88")}
                        </button> */}
                </div>

                <Container>

                    {loading ? <SmallLoader /> : (
                        <>

                            {userMatches?.fantasy?.length > 0 &&
                                <>
                                    {userMatches?.fantasy?.map((match, index) => {
                                        const match_details = match?.completed_match_details ? JSON.parse(match?.completed_match_details) : match?.live_match_details ? JSON.parse(match?.live_match_details) : null;
                                        console.log(match_details, 'md');
                                        return (
                                            <MatchLayout2 match={match} match_details={match_details} key={index} />
                                        )
                                    })}
                                </>
                            }
                            {/* {type == "fantasy" ? (
                                <>
                                    {userMatches?.fantasy?.length > 0 &&
                                        <>
                                            {userMatches?.fantasy?.map((match, index) => {
                                                const match_details = match?.completed_match_details ? JSON.parse(match?.completed_match_details) : match?.live_match_details ? JSON.parse(match?.live_match_details) : null;
                                                console.log(match_details, 'md');
                                                return (
                                                    <MatchLayout2 match={match} match_details={match_details} key={index} />
                                                )
                                            })}
                                        </>
                                    }
                                </>
                            ) : (
                                <>
                                    {userMatches?.prediction?.length > 0 &&
                                        <>
                                            {userMatches?.prediction?.map((match, index) => {
                                                const match_details = match?.completed_match_details ? JSON.parse(match?.completed_match_details) : match?.live_match_details ? JSON.parse(match?.live_match_details) : null;
                                                console.log(match_details, 'md');
                                                return (
                                                    <MatchLayoutForPrediction match={match} match_details={match_details} key={index} />
                                                )
                                            })}
                                        </>
                                    }
                                </>
                            )} */}
                        </>
                    )}





                </Container>
            </SubLayout>
            {/* <BottomNavbar active={1} /> */}
        </Layout>
    )
}

export default MyMatches